import { SET_EVENT_BRIDGE_LOADING } from 'client/constants/actions';

export function setEventBridgeLoading(isLoading: boolean) {
	return {
		type: SET_EVENT_BRIDGE_LOADING,
		payload: isLoading,
	};
}
